'use client';
import Bugsnag from "@bugsnag/js";

import {useEffect, useState} from "react";
import style from "./styleSelector.module.scss";
import {useTekstClient} from "../../../hooks/useTekstClient";
import {useDropdown} from './useDropdown';
import {useAxios} from "../../../hooks/useAxios";
import { IoMdArrowDropdown } from "@react-icons/all-files/io/IoMdArrowDropdown";
import { IoMdArrowDropup } from "@react-icons/all-files/io/IoMdArrowDropup";

const CountryDropdown = () => {
    const {isOpen, toggleDropdown, closeDropdown, dropdownRef} = useDropdown();
    const {tekst} = useTekstClient();
    const {get, post} = useAxios();

    const [countries, setCountries] = useState([]);
    const [langCookie, setLangCookie] = useState();
    const [countryCookie, setCountryCookie] = useState();

    useEffect(() => {
        if (typeof document === "undefined") return;

        const cookie = document.cookie
            .split('; ')
            .find((row) => row.startsWith(`NEXT_LOCALE=`))
            ?.split('=')[1];

        const splittedCookie = cookie.split('-')
        setLangCookie(splittedCookie[0]);
        setCountryCookie(splittedCookie[1]);
    }, []);

    useEffect(() => {
        fetch('/api/landen', {cache: 'force-cache'})
            .then((res) => res.json())
            .then((data) => setCountries(data))
            .catch((error) => Bugsnag.notify(error));
    }, []);


    const handleChangeCountry = (selectedCountry) => {
        const localeFull = `${langCookie}-${selectedCountry.naam}`;
        document.cookie = `NEXT_LOCALE=${encodeURIComponent(localeFull)}; Path=/; Max-Age=31536000; SameSite=Lax`;


        post(`/land`, {'land_id': selectedCountry.id})
            .then(() => {
                // Get current path and replace locale slug with new one
                const currentPath = window.location.pathname;
                const currentLocaleMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})(\/.*)?$/i);

                if (currentLocaleMatch) {
                    // Replace old locale with new locale in URL
                    const restOfPath = currentLocaleMatch[2] || '';
                    window.location.href = `/${localeFull}${restOfPath}`;
                } else {
                    // No locale in URL, just reload
                    location.reload();
                }
            });
    }

    return (
        <div className={style.selectorContainer} ref={dropdownRef}>
            <button className={style.triggerButton} onClick={toggleDropdown} aria-expanded={isOpen} aria-haspopup="true">
                <span className={style.currentSelection}>
                    {tekst('website:menu:country')} - {countryCookie}
                    <span className={style.dropdownArrow}>
                        {isOpen ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </span>
                </span>
            </button>

            {isOpen && (
                <div className={style.selectorWrapper}>
                    <span className={style.trianglePointer}></span>
                    <div className={style.dropdownMenu}>
                        <div className={style.menuContent}>
                            {countries.map((country) => (
                                <button
                                    key={country.id}
                                    className={`${style.menuItem} ${
                                        countryCookie === country.naam ? style.selectedItem : ''
                                    }`}
                                    onClick={() => handleChangeCountry(country)}
                                >
                    <span className={style.itemLabel}>
                        {country?.fullname}
                    </span>
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CountryDropdown;